import axios from "axios";
import { APICore } from "./apiCore";

const api = new APICore();

function getRevenueApi(type: string, from?: string, to?: string) {
  const baseUrl = "/revenue";
  const params: any = {
    filter: type,
  };

  if (from) params.from = from;
  if (to) params.to = to;

  return api.get(`${baseUrl}`, params);
}
function getRevenueUSDApi(type: string, from?: string, to?: string) {
  const baseUrl = "/revenue_usd";
  const params: any = {
    type,
  };

  if (from) params.from = from;
  if (to) params.to = to;

  return api.get(`${baseUrl}`, params);
}
export { getRevenueApi, getRevenueUSDApi };
